export default __webpack_public_path__ + "static/media/children.e17ad9f6.pdf";